import { AuthenticationResult } from '@azure/msal-browser';

// type guard for AuthenticationResult
export const isAuthenticationResult = (obj: unknown): obj is AuthenticationResult => typeof obj === 'object' && obj !== null && (obj as AuthenticationResult).account !== undefined;
